import * as React from 'react';
import styled from 'styled-components';
import lessonIcon from '../assets/images/lesson-icon.png'

import  { MEDIABASE } from '../common/constants'
const ASSETS_URL = MEDIABASE + 'assets/'

const calculateDuration = duration => {
    const hrs = (duration - (duration % 60)) / 60;
    const mins = duration % 60;
    return (<p className="duration">Duration: {hrs} Hrs {mins} Mins</p>)
}
const Lesson = styled.div`
        display: flex;
        flex-direction: row;
        font-family: 'Roboto', sans-serif;        
        padding: 1em 2em;
        border-bottom: 1px solid rgb(44, 44, 44);
        opacity: ${props => props.completed || !props.isActive ? 0.25 : 1.0 };
        transition: background-color 800ms ease;

        &:hover {
            background-color: #${props => !props.completed ? 555 : 333};  
        }

        .lesson-icon > img{
            width: 160px;
            height: 160px;
        }

        .lesson-details {
            height: 10em;
            width: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 2em;
        }

        .lesson-title {
            color: #fff;
            font-family:"Roboto Condensed", sans-serif;
            font-size: 21px;
            text-transform: uppercase;
            font-style: italic;
            font-weight: 500;
            margin-bottom: .25em;
        }

        .lesson-title > span {
            font-weight: 700;
        }

        .lesson-options {
            width: 80%;
            display: flex;
            flex-direction: row;
            color: #ff0033;
            justify-content: space-around;
            font-size: 15px;
            font-weight: 500;
            margin-top: .625em;
        }

        .lesson-options > * {
            margin: 0 0 0 0;
            font-size: 13px;
        }

        .lesson-description {
            font-size: 14px;
            margin-top: .8em;
            color: #fff;
        }

        // Extra small devices (portrait phones, less than 576px)
        @media (max-width: 575.98px) {
            .lesson-title {
                font-size: 1.25em;
            }
            .lesson-options {
                font-size: .75em;
                width: 100%;
            }
            .lesson-icon {
                display: none;
            }
        }

        // Small devices (landscape phones, 576px and up)
        @media (min-width: 576px) and (max-width: 767.98px) {
            padding: .5em 0;
            .lesson-title {
                font-size: 1.125em;
            }
            .lesson-options {
                font-size: .75em;
                width: 100%;
            }
            .lesson-icon {
                display: none;
            }
         }

        // Medium devices (tablets, 768px and up)
        @media (min-width: 768px) and (max-width: 991.98px) {
            padding: .5em 0;
            .lesson-title {
                font-size: 1.125em;                
            }
            .lesson-details {
                padding: 0 0 0 1em;
            }
         }

        // Large devices (desktops, 992px and up)
        /* @media (min-width: 992px) and (max-width: 1199.98px) { ... } */

        // Extra large devices (large desktops, 1200px and up)
        @media (min-width: 1200px) { 
            padding: 1em 0;
            
            .lesson-details {
                padding: 0 1em;
            }
            .lesson-options {
                margin-top: 0;
            }
            .lesson-title {
                margin-bottom: 0;
            }
         }
    `

const LessonItem = props => {
    
    return(
        <Lesson isActive={props.isActive} completed={props.completed} onClick={props.handleLessonClick}>
            <div className="lesson-icon"><img src={ASSETS_URL + props.icon} alt="Lesson icon"/></div>
            <div className="lesson-details">
                <p className="lesson-title"><span>Lesson {props.lessonindex}: </span>{props.lessontitle}</p>
                {/* <div className="lesson-options">
                    <p className="date">Due Date: {props.duedate}</p>
                    <p className="tutor" style={props.tutor === "None" ? {display: "none"} : {display: "block"}}>Tutor: {props.tutor}</p>
                    {calculateDuration(props.duration)}
                </div> */}
                {/* Lesson due date not in Ana's designs, commented out possible addition later */}
                {/* <p style={{color: 'white', marginTop: '.625em'}}>Due: {props.duedate}</p> */}
                {/* <p className="lesson-description">
                    {props.lessondescription}
                </p> */}
            </div>
            
        </Lesson>
    );
}

export default LessonItem;


// WEBPACK FOOTER //
// ./src/common/lessonItem.Component.tsx